import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { Globals } from './shared/services/global';
import { SharedModule } from './shared/shared.module';
import { LangTranslationModule } from './translation/translation.module';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgetPasswordComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    LangTranslationModule,
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 10000, // 10 seconds
      positionClass: 'toast-top-center'
    }),
    NgxSpinnerModule
  ],
  providers: [
    Globals, 
    { provide: LocationStrategy, useClass: HashLocationStrategy},
    provideClientHydration()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
